import { gql, useMutation } from '@apollo/client'

const REMOVE_CART_ITEMS_MUTATION = gql`
  mutation RemoveCartItems($customerNo: String!, $cartItemIds: [String!]!) {
    removeCartItems(customerNo: $customerNo, cartItemIds: $cartItemIds) {
      deletedCartItems {
        id
      }
      errors
    }
  }
`

export const useRemoveCartItemMutation = () => {
  const [removeCartItems, { loading, error }] = useMutation(REMOVE_CART_ITEMS_MUTATION, {
    onError: (error) => {
      console.error('Error removing cart items:', error)
    },
    update: (cache, { data: { removeCartItems } }) => {
      const { deletedCartItems } = removeCartItems || {}
      if (deletedCartItems && deletedCartItems.length > 0) {
        deletedCartItems.forEach(item => {
          cache.evict({ id: cache.identify({ id: item.id, __typename: 'CartItem' }) })
        })
      }
    },
    refetchQueries: ['GetCustomerCart', 'GetCustomerCartItems', 'GetCartDeliveryOptions', 'GetCartSummary'], // For refetching the cart after removing items
  })

  return {
    removeCartItems,
    loading,
    error
  }
}